import { FormError } from 'shared/components/FormControl';

import ModalWrapper from 'dashboard/components/ModalWrapper';
import {
  ModalBody,
  ModalContainer,
  ModalDescription,
  ModalHeader,
} from 'dashboard/layouts/ModalLayout';
import Button from 'design-system/components/Button';
import { HStack } from 'design-system/components/Stack';
import TextArea from 'design-system/components/TextArea';
import { useFormSecurely as useForm } from 'lib/security/reactHookForm';

type DismissFormData = {
  reason: string;
};

interface ReportDismissModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (reason: string) => void;
  header?: string;
  description?: string;
}

const ReportDismissModal = ({
  isOpen,
  onClose,
  onSubmit,
  header,
  description,
}: ReportDismissModalProps) => {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, isDirty, errors, isValid },
  } = useForm<DismissFormData>({ mode: 'onChange' });

  const onDismissSubmit = async (data: DismissFormData) => {
    await onSubmit(data.reason);
    onClose();
  };

  return (
    <ModalWrapper isOpen={isOpen} handleCloseModal={onClose}>
      <ModalContainer>
        <ModalHeader onClose={onClose}>{header}</ModalHeader>
        {description && <ModalDescription>{description}</ModalDescription>}
        <ModalBody>
          <form onSubmit={handleSubmit(onDismissSubmit)}>
            <TextArea
              {...register('reason', {
                required: 'A reason for dismissing these matches is required',
                validate: (value) => {
                  return !!value.trim();
                },
                maxLength: { value: 1024, message: 'Please limit reason to 1024 characters' },
              })}
              placeholder='Please provide a reason for dismissing these matches'
            />
            {errors.reason && <FormError>{errors.reason.message}</FormError>}
            <HStack equal={true}>
              <Button
                type='button'
                variant='basic'
                id='reports-dismiss-hits-modal__cancel'
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button
                type='submit'
                disabled={isSubmitting || !isDirty || !isValid}
                id='reports-dismiss-hits-modal__submit'
              >
                Dismiss
              </Button>
            </HStack>
          </form>
        </ModalBody>
      </ModalContainer>
    </ModalWrapper>
  );
};

export default ReportDismissModal;
